import React from 'react';
import { useElapsedTime } from '../../hooks/useElapsedTime';

interface ElapsedTimeProps {
  startTime: number;
  prefix?: string;
  suffix?: string;
}

/**
 * Component that displays elapsed time since a given timestamp
 * Automatically updates every second
 */
export const ElapsedTime: React.FC<ElapsedTimeProps> = React.memo(({ 
  startTime, 
  prefix = '',
  suffix = ''
}) => {
  const elapsed = useElapsedTime(startTime);
  
  return (
    <span>
      {prefix}{elapsed}{suffix}
    </span>
  );
}, (prevProps, nextProps) => {
  // Only re-render if startTime changes
  return prevProps.startTime === nextProps.startTime &&
         prevProps.prefix === nextProps.prefix &&
         prevProps.suffix === nextProps.suffix;
});

ElapsedTime.displayName = 'ElapsedTime';